import { useContext, useState } from 'react';

import { useQuery } from '@apollo/client';
import { Icon, IconButton } from '@chakra-ui/react';
import { MdClose } from 'react-icons/md';

import { Deal, dealQuery } from '../../gql/dealGql';
import { Deal as GeneratedDeal, Maybe } from '../../gql/generated/graphql';

import TextModal from './TextModal';

import { FiltersContext, TextWidgetContext } from '../../libs/contextLib';

const TextWidget = () => {
  const { textDealId, setTextDealId, setActiveConversation } = useContext(TextWidgetContext);
  const {
    filters: {
      global: { sources, types },
    },
  } = useContext(FiltersContext);

  const [deal, setDeal] = useState<Maybe<GeneratedDeal>>(null);
  const [isOpen, setIsOpen] = useState(false);

  useQuery<{ deal: GeneratedDeal }>(dealQuery, {
    skip: !textDealId,
    variables: {
      id: textDealId,
      sources,
      types,
    },
    fetchPolicy: 'network-only',
    onCompleted: ({ deal: fetchedDeal }) => {
      setDeal(fetchedDeal);
      setIsOpen(true);
    },
  });

  if (!isOpen) {
    return null;
  }

  return (
    // TODO: temporary conversion. We should remove all classes and use the generated classes
    <TextModal deal={deal as Deal}>
      <IconButton
        icon={<Icon as={MdClose} boxSize={6} />}
        variant="icon"
        color="white"
        aria-label="close-modal"
        onClick={() => {
          setTextDealId(null);
          setActiveConversation({
            role: '',
            phone_number: '',
            first_name: '',
            last_name: '',
          });
          setIsOpen(false);
        }}
      />
    </TextModal>
  );
};

export default TextWidget;
